// MeetingTitle.js
import { Box, Typography, Avatar } from "@mui/material";
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import { getLocaleDateWithTimeCustomV2, getUserFullName } from "app/utils/appHelpers";
import config from "config";

const DshReviewVoteTitle = ({ currentMeeting, adminUser }) => {


    

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                userSelect: 'none',
                WebkitUserSelect: 'none',
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: 0.5,
                }}
            >
                <Typography variant="h6" sx={{ m: 0 }}>
                    {currentMeeting.inst} {currentMeeting.unit}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    <Typography variant="caption">
                        <Box component="span" sx={{ color: 'primary.main' }}>Sayı:</Box> {currentMeeting.meetingNo}
                    </Typography>
                    <Typography variant="caption">
                        <Box component="span" sx={{ color: 'primary.main' }}>Tarih:</Box> {getLocaleDateWithTimeCustomV2("tr", currentMeeting.pdate)}
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", m: 0 }}>
                        <Typography variant="caption" sx={{ m: 0 }}>
                            <Box component="span" sx={{ color: 'primary.main' }}>Toplantı Şekli:</Box> {currentMeeting.meetingMode}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="caption" sx={{ m: 0 }}>
                            <Box component="span" sx={{ color: 'primary.main' }}>Toplantı Yöneticisi:</Box>
                        </Typography>
                        <Avatar
                            sx={{ height: 25, width: 25 }}
                            alt={adminUser?.name || ""}
                            src={
                                adminUser?.profileImageUrl
                                    ? `${config.userAuthApiUrl}${adminUser.profileImageUrl}`
                                    : undefined
                            }
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl;
                            }}
                        />
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", m: 0 }}>
                            <Typography variant="caption" sx={{ m: 0 }}>
                                {getUserFullName(adminUser)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default DshReviewVoteTitle;
